/**
 * Assisted ordering picker for the /cart page -- lets a Sales User/Sales
 * Manager pick which Dealer they're placing this order for (see
 * raftor_webhq.checkout.assisted_ordering). Purely client-driven: no
 * server-rendered hook to build on (raftor_websitehq's own cart.html
 * override handles the page's visual layout, not this banner), only the
 * same whitelisted endpoints the Desk report and portal pages already
 * read from.
 */
frappe.ready(function () {
	if (!window.location.pathname || !window.location.pathname.startsWith("/cart")) {
		return;
	}

	function findAnchor() {
		// .page_content, not .shopping-cart-header: this banner used to
		// insert itself as a sibling right after the cart title, which
		// silently broke once pwahq_shell.css started hiding that title's
		// wrapper (.page-header) in PWA/mobile mode -- inserting a node
		// inside a display:none ancestor doesn't error, it just renders
		// nothing, which is exactly how "Dealer selection is not appearing"
		// went unnoticed until a live field agent hit it. .page_content is
		// web.html's own outer content wrapper -- always present (unlike
		// .cart-container, which core only renders when doc.items is
		// non-empty) and never touched by the PWA header-hiding rule.
		return document.querySelector(".page_content");
	}

	function renderDealerResults(dealers, resultsEl) {
		resultsEl.innerHTML = "";
		if (!dealers || !dealers.length) {
			var empty = document.createElement("div");
			empty.className = "rfhq-dealer-results__empty";
			empty.textContent = __("No matching Dealer");
			resultsEl.appendChild(empty);
			resultsEl.style.display = "block";
			return;
		}

		dealers.forEach(function (dealer) {
			var item = document.createElement("button");
			item.type = "button";
			item.className = "rfhq-dealer-results__item";

			var icon = document.createElement("span");
			icon.className = "rfhq-dealer-results__item-icon";
			icon.innerHTML =
				'<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" ' +
				'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
				'<path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/>' +
				'<line x1="9" y1="9" x2="9" y2="9.01"/><line x1="9" y1="12" x2="9" y2="12.01"/>' +
				'<line x1="9" y1="15" x2="9" y2="15.01"/></svg>';
			item.appendChild(icon);
			// customer_name is stored ALL CAPS in this data (a real Dealer's
			// legal/trade name) -- text-transform:capitalize (CSS) is purely
			// a display transform, the raw value sent back to
			// set_acting_for_dealer on click is untouched.
			var nameEl = document.createElement("span");
			nameEl.className = "rfhq-dealer-results__item-name";
			nameEl.textContent = dealer.customer_name.toLowerCase();
			item.appendChild(nameEl);

			item.addEventListener("click", function () {
				item.disabled = true;
				item.classList.add("is-busy");
				frappe.call({
					method: "raftor_webhq.checkout.assisted_ordering.set_acting_for_dealer",
					args: { customer: dealer.name },
					callback: function () {
						window.location.reload();
					},
					error: function () {
						item.disabled = false;
						item.classList.remove("is-busy");
					},
				});
			});
			resultsEl.appendChild(item);
		});
		resultsEl.style.display = "block";
	}

	// Same icon + label row rendered in BOTH the search state and the
	// active/selected-Dealer state -- previously the search state had its
	// own instruction-style label ("Placing an order for a Dealer?") and
	// the active state had no equivalent header at all, so the banner
	// looked like two unrelated pieces of UI rather than one control with
	// two states. dealerName null/undefined renders the fixed "Order For"
	// label alone (search state); passed a name, it renders that name as
	// the value next to the same label (active state) -- one consistent
	// header either way.
	function renderBannerHeader(wrapper, dealerName) {
		var header = document.createElement("div");
		header.className = "rfhq-dealer-banner__header";

		var icon = document.createElement("span");
		icon.className = "rfhq-dealer-banner__icon";
		icon.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" ' +
			'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
			'<path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/>' +
			'<line x1="9" y1="9" x2="9" y2="9.01"/><line x1="9" y1="12" x2="9" y2="12.01"/>' +
			'<line x1="9" y1="15" x2="9" y2="15.01"/></svg>';
		header.appendChild(icon);

		var label = document.createElement("span");
		label.className = "rfhq-dealer-banner__label";
		label.textContent = __("Order For");
		header.appendChild(label);

		if (dealerName) {
			var name = document.createElement("span");
			name.className = "rfhq-dealer-banner__name";
			name.textContent = dealerName;
			header.appendChild(name);
		}

		wrapper.appendChild(header);
		return header;
	}

	function renderPickerState(wrapper) {
		wrapper.innerHTML = "";
		renderBannerHeader(wrapper, null);

		// position:relative anchor for the results dropdown below -- kept
		// as an absolutely positioned overlay rather than inline content,
		// so a long result list floats over whatever's below (the cart
		// itself) instead of shoving it further down the page every
		// keystroke.
		var searchBox = document.createElement("div");
		searchBox.className = "rfhq-dealer-search";
		wrapper.appendChild(searchBox);

		var inputWrap = document.createElement("div");
		inputWrap.className = "rfhq-dealer-search__input-wrap";
		searchBox.appendChild(inputWrap);

		// Inline SVG, not pwahq_boot.js's icon() helper -- that lives in a
		// different app (raftor_pwahq) only loaded on mobile/standalone
		// shell views, whereas this picker also renders on plain desktop
		// visits to /cart.
		var searchIcon = document.createElement("span");
		searchIcon.className = "rfhq-dealer-search__icon";
		searchIcon.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" ' +
			'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
			'<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
		inputWrap.appendChild(searchIcon);

		var input = document.createElement("input");
		input.type = "text";
		input.className = "rfhq-dealer-search__input";
		input.id = "ce-dealer-search";
		input.autocomplete = "off";
		input.placeholder = __("Search Dealer by name");
		inputWrap.appendChild(input);

		var spinner = document.createElement("span");
		spinner.className = "rfhq-dealer-search__spinner";
		inputWrap.appendChild(spinner);

		var results = document.createElement("div");
		results.className = "rfhq-dealer-results";
		searchBox.appendChild(results);

		document.addEventListener("click", function (e) {
			if (!searchBox.contains(e.target)) {
				results.style.display = "none";
			}
		});

		var searchTimer;
		input.addEventListener("input", function () {
			clearTimeout(searchTimer);
			var term = input.value.trim();
			if (term.length < 2) {
				results.style.display = "none";
				spinner.style.display = "none";
				return;
			}
			spinner.style.display = "block";
			searchTimer = setTimeout(function () {
				frappe.call({
					method: "raftor_webhq.checkout.assisted_ordering.list_dealers",
					args: { search: term },
					freeze: false,
					callback: function (r) {
						spinner.style.display = "none";
						renderDealerResults(r && r.message, results);
					},
					error: function () {
						spinner.style.display = "none";
					},
				});
			}, 300);
		});
		input.addEventListener("focus", function () {
			if (results.childNodes.length) {
				results.style.display = "block";
			}
		});
	}

	function renderRepeatOrderSlot(wrapper) {
		var slot = document.createElement("div");
		slot.className = "rfhq-dealer-suggestion";
		slot.id = "ce-repeat-order-slot";
		wrapper.appendChild(slot);

		frappe.call({
			method: "raftor_webhq.checkout.assisted_ordering.get_repeat_order_suggestion",
			freeze: false,
			callback: function (r) {
				var suggestion = r && r.message;
				if (!suggestion) {
					slot.remove();
					return;
				}

				var row = document.createElement("div");
				row.className = "rfhq-dealer-suggestion__row";

				var summary = document.createElement("div");
				summary.className = "rfhq-dealer-suggestion__text";
				summary.textContent = suggestion.summary_text;
				row.appendChild(summary);

				var button = document.createElement("button");
				button.type = "button";
				button.className = "rfhq-dealer-suggestion__action";
				button.textContent = __("Repeat this order");
				button.addEventListener("click", function () {
					button.disabled = true;
					frappe.call({
						method: "raftor_webhq.checkout.assisted_ordering.repeat_last_order",
						callback: function (res) {
							var result = res && res.message;
							if (result && result.skipped && result.skipped.length) {
								frappe.msgprint(__("Some items from that order are no longer available and were skipped."));
							}
							window.location.reload();
						},
						error: function () {
							button.disabled = false;
						},
					});
				});
				row.appendChild(button);

				slot.appendChild(row);
			},
		});
	}

	function renderFrequentItemsSlot(wrapper) {
		var slot = document.createElement("div");
		slot.className = "rfhq-dealer-suggestion";
		slot.id = "ce-frequent-items-slot";
		wrapper.appendChild(slot);

		frappe.call({
			method: "raftor_webhq.checkout.assisted_ordering.get_frequent_items_suggestion",
			freeze: false,
			callback: function (r) {
				var suggestion = r && r.message;
				if (!suggestion) {
					slot.remove();
					return;
				}

				var row = document.createElement("div");
				row.className = "rfhq-dealer-suggestion__row";

				var summary = document.createElement("div");
				summary.className = "rfhq-dealer-suggestion__text";
				summary.textContent = suggestion.summary_text;
				row.appendChild(summary);

				var button = document.createElement("button");
				button.type = "button";
				button.className = "rfhq-dealer-suggestion__action";
				button.textContent = __("Add usual items");
				button.addEventListener("click", function () {
					button.disabled = true;
					frappe.call({
						method: "raftor_webhq.checkout.assisted_ordering.add_frequent_items_to_cart",
						callback: function (res) {
							var result = res && res.message;
							if (result && result.skipped && result.skipped.length) {
								frappe.msgprint(__("Some usual items are no longer available and were skipped."));
							}
							window.location.reload();
						},
						error: function () {
							button.disabled = false;
						},
					});
				});
				row.appendChild(button);

				slot.appendChild(row);
			},
		});
	}

	function renderActiveState(wrapper, state) {
		wrapper.innerHTML = "";
		var header = renderBannerHeader(wrapper, state.customer_name);

		var button = document.createElement("button");
		button.type = "button";
		button.className = "rfhq-dealer-banner__switch";
		button.textContent = __("Switch Dealer");
		button.addEventListener("click", function () {
			button.disabled = true;
			frappe.call({
				method: "raftor_webhq.checkout.assisted_ordering.clear_acting_for_dealer",
				callback: function () {
					window.location.reload();
				},
				error: function () {
					button.disabled = false;
				},
			});
		});
		header.appendChild(button);

		renderRepeatOrderSlot(wrapper);
		renderFrequentItemsSlot(wrapper);
	}

	function renderBanner(state) {
		var anchor = findAnchor();
		if (!anchor) {
			return;
		}

		var existing = document.getElementById("ce-assisted-ordering-banner");
		if (existing) {
			existing.remove();
		}

		var wrapper = document.createElement("div");
		wrapper.id = "ce-assisted-ordering-banner";
		wrapper.className = "rfhq-dealer-banner";

		if (state.acting_for) {
			wrapper.classList.add("rfhq-dealer-banner--active");
			renderActiveState(wrapper, state);
		} else {
			renderPickerState(wrapper);
		}

		// Prepended, not inserted after an anchor sibling: .page_content is
		// itself the container now (see findAnchor's own comment), so the
		// banner needs to become its first child, ahead of the cart items
		// table/empty-state that block already renders.
		anchor.insertBefore(wrapper, anchor.firstChild);
	}

	frappe.call({
		method: "raftor_webhq.checkout.assisted_ordering.get_acting_for_dealer",
		freeze: false,
		callback: function (r) {
			var state = r && r.message;
			if (!state || !state.is_sales_staff) {
				return;
			}
			// A field rep filling a Dealer's order wants a dense, scannable
			// order sheet -- many line items at a glance in table columns --
			// not the one-big-card-per-item layout rfhq_cart.css's mobile
			// breakpoint builds for a single shopper browsing their own
			// handful of items. Reuses the SAME table structure the cart
			// already renders at desktop width (see rfhq_cart.css's
			// body.rfhq-agent-ordersheet override) rather than a new layout,
			// just forced on regardless of viewport.
			document.body.classList.add("rfhq-agent-ordersheet");
			renderBanner(state);
		},
	});
});
